
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService, HisUploadFile } from 'hisng';
import { PublicationFileImportService } from './iface/publication-file-import.service';

@Injectable()
export class BibtexImportService implements PublicationFileImportService {

    constructor( private backendService: HisBackendService ) { }
    
    uploadPublicationImportFile(uploadFile: HisUploadFile): Observable<boolean> {
        if(!uploadFile) {
            console.log('uploadPublicationImportBibTeX() #no uploadFile');
            return new Observable();
        }
        console.log('uploadPublicationImportBibTeX() #uploadFile', uploadFile);
        return this.backendService.postData( 'api/v1/fs/res/publication/import/bibtexUpload/', uploadFile );
    }

}
